import React from "react";
import styles from "./styles.module.scss";

const DashboardWidget = ({ icon, title, count , onClick}) => {

  const handleClick = () => {
    if(onClick){
      onClick()
    } else {
      return;
    }
  }
  return (
    <div className={styles.widget} onClick={handleClick}>
 
      <div>
      <h2 className="h2-j mb-2">{count}</h2>
      <h4 className="h4-j semi-light mb-0">{title}</h4>
      </div>
      <div className="mb-2">{icon}</div>


    </div>
  );
};

export default DashboardWidget;
